// Swiper styles
import "swiper/swiper.scss"
import "swiper/modules/pagination.scss"
import "swiper/modules/effect-creative.scss"

// Sliders

import "@components/groups/testimonials-group/testimonials-group--slider"
import "@components/groups/commendations-group/commendations-group--slider"
